export default "__VITE_ASSET__a51746f6__"